module.exports = __webpack_public_path__ + "static/media/search.ec4a0355.svg";